import targetITCPercent from '../targetITCPercent';
import { Project } from '~/types/project';

export default function bidRowAmount(project: Project) {
  return `Bid @ ${targetITCPercent(project)} ITC*`;
}